import graphqlClient from '~/graphql/graphqlClient';

export interface MutationMoveAiRoleToIndexArgs {
  playerId: string;
  heroHandle: string;
  heroBuildId: string;
  aiTreeTag: string;
  targetIndex: number;
}

export interface AbilityChangeResult {
  heroHandle: string;
  heroBuild: unknown;
}

const mutation = `
mutation MoveAiRoleToIndex(
  $playerId: String!
  $heroHandle: String!
  $heroBuildId: String!
  $aiTreeTag: String!
  $targetIndex: Int!
) {
  moveAiRoleToIndex(
    playerId: $playerId
    heroHandle: $heroHandle
    heroBuildId: $heroBuildId
    aiTreeTag: $aiTreeTag
    targetIndex: $targetIndex
  ) {
    heroHandle
    heroBuild
  }
}`;

export default async function mutationMoveAiRoleToIndex(args: MutationMoveAiRoleToIndexArgs) {
  return await graphqlClient.request<AbilityChangeResult>('moveAiRoleToIndex', mutation, args);
}

